export enum FormUploadStatus {
	Inspecting = "INSPECTING",
	PreliminaryReport = "PRELIMINARY_REPORT",
	Uploading = "UPLOADING",
	AgreementExecution = "AGREEMENT_EXECUTION",
	FinalReport = "FINAL_REPORT",
	GeneratingForms = "GENERATING_FORMS",
}

export enum UploadStatus {
	Inspecting = "INSPECTING",
	PreliminaryReport = "PRELIMINARY_REPORT",
	Uploading = "UPLOADING",
	AgreementExecution = "AGREEMENT_EXECUTION",
	FinalReport = "FINAL_REPORT",
	GeneratingForms = "GENERATING_FORMS",
	Completing = "COMPLETING",
}
